var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteAc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3465_39715)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 72,
    r: 60,
    fill: "#38879F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.7679 57.2447C92.259 56.896 88.75 56.6344 85.2192 56.4383V56.4165L84.7397 53.5831C84.4128 51.578 83.9333 48.5703 78.8333 48.5703H73.1231C68.0449 48.5703 67.5654 51.4472 67.2166 53.5613L66.759 56.3511C64.732 56.4819 62.7051 56.6126 60.6782 56.8088L56.232 57.2447C55.3166 57.3319 54.6628 58.1383 54.75 59.0319C54.8372 59.9254 55.6218 60.5793 56.5372 60.4921L60.9833 60.0562C72.4038 58.9229 83.9115 59.3588 95.4628 60.5139C95.5282 60.5139 95.5718 60.5139 95.6372 60.5139C96.4654 60.5139 97.1846 59.8819 97.2718 59.0319C97.3372 58.1383 96.6833 57.3319 95.7679 57.2447Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7608 63.5863C91.2377 63.0415 90.5185 62.7363 89.7775 62.7363H62.2288C61.4877 62.7363 60.7467 63.0415 60.2454 63.5863C59.7441 64.1312 59.4608 64.8722 59.5044 65.635L60.8557 87.9966C61.0954 91.3094 61.4005 95.4504 69.007 95.4504H82.9993C90.6057 95.4504 90.9108 91.3312 91.1505 87.9966L92.5018 65.6568C92.5454 64.8722 92.2621 64.1312 91.7608 63.5863ZM79.6211 84.5312H72.3634C71.4698 84.5312 70.7288 83.7902 70.7288 82.8966C70.7288 82.003 71.4698 81.262 72.3634 81.262H79.6211C80.5146 81.262 81.2557 82.003 81.2557 82.8966C81.2557 83.7902 80.5146 84.5312 79.6211 84.5312ZM81.4518 75.8132H70.5544C69.6608 75.8132 68.9198 75.0722 68.9198 74.1786C68.9198 73.285 69.6608 72.544 70.5544 72.544H81.4518C82.3454 72.544 83.0864 73.285 83.0864 74.1786C83.0864 75.0722 82.3454 75.8132 81.4518 75.8132Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3465_39715",
    x: 0,
    y: 0,
    width: 152,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3465_39715"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3465_39715",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAc);
export default __webpack_public_path__ + "static/media/delete-ac.59049790f54c091c57d0d24c29c0f49c.svg";
export { ForwardRef as ReactComponent };